import ReportTableYearController from "./ReportTableYearController";

angular.module('elfium').component('reportTableYear', {
    bindings: {
        businessCaseId: '<'
    },
    controller: ReportTableYearController,
    templateUrl: ['elfiumUrlService', (elfiumUrlService) => elfiumUrlService.getTemplateUrl('report', 'reportTableYear')]
});


// WEBPACK FOOTER //
// ./src/app/components/report/reportTableYear.ts